import { Component, OnInit, ViewChild } from '@angular/core';
import { concatMap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup, NgForm } from '@angular/forms';
import { LoginModel } from 'src/app/core/models/login.model';
import { LoginResultModel } from 'src/app/core/models/login-result.model';
import { RouteStateService } from 'src/app/core/services/route-state.service';
import { ExamModel } from 'src/app/core/models/exam.model';
import { BaseComponent } from 'src/app/core/abstracts/base.component';
import { ExamBookletModel } from 'src/app/core/models/exam-booklet.model';
import { ExamAnswerListModel } from 'src/app/core/models/exam-answer-list.model';
import { ExamAnswerModel } from 'src/app/core/models/exam-answer.model';
import { ExamParticipantModel } from 'src/app/core/models/exam-participant.model';

@Component({
  selector: 'app-exam',
  templateUrl: './exam.component.html',
  styleUrls: ['./exam.component.scss']
})
export class ExamComponent extends BaseComponent implements OnInit {

  @ViewChild(NgForm)
  f: NgForm;

  letters = [
    'A', 'B', 'C', 'D', 'E'
  ];

  isLoading: boolean = false;
  isSaving: boolean = false;
  isFinishing: boolean = false;
  isFinished: boolean = false;
  shouldFinishExam: boolean = false;

  bookletLoading: boolean = false;
  bookletLoaded: boolean = false;
  bookletError: boolean = false;

  model: ExamModel = new ExamModel();
  
  participantModel: ExamParticipantModel = new ExamParticipantModel();

  answerSize;
  bookletSize;
  currentBookletIndex;

  finishDate: Date;
  lastTime: string;

  ngOnInit(): void {
    this.model.ExamBooklets = []

    this.currentBookletIndex = null;
    
    this.route.params.subscribe(params => {
      if(params.bookletindex != null && params.bookletindex >= 0){
        this.currentBookletIndex = params.bookletindex;

        this.authService.refreshToken().subscribe(
          result => {
            //token refreshed
            this.getModel();
          },
          error => {

          }
        )
        
      }
    });

  }

  getModel() {
    this.isLoading = true;
    this.examService.attendForStudent(this.id, this.currentBookletIndex).subscribe(
      (result) => {

        if(result.Success == false){
          this.commonFunctionsService.showResultNotification(result, true);
          return;
        }

        this.model = result.Exam;
        this.model.ExamBooklets = result.ExamBooklets;
        this.participantModel = result.ExamParticipant;

        this.finishDate = new Date;
        this.finishDate.setSeconds(this.finishDate.getSeconds() + this.participantModel.LastDuration);

        for (let i = 0; i < this.model.ExamBooklets.length; i++) {

          if(this.participantModel.ExamBookletID == this.model.ExamBooklets[i].ExamBookletID){
            this.currentBookletIndex = this.model.ExamBooklets[i].ExamBookletIndex;
          }

          this.model.ExamBooklets[i].ExamAnswerLists = result.ExamAnswerLists.filter(answerList => answerList.ExamBookletID == this.model.ExamBooklets[i].ExamBookletID);
        
          for (let k = 0; k < this.model.ExamBooklets[i].ExamAnswerLists.length; k++) {
            this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswers = result.ExamParticipantAnswers.filter(answer => answer.ExamAnswerListID == this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswerListID);
          }
        }
        
        
        this.updateBookletSize();
        this.updateAnswerListSize();
        this.updateAnswerTable();

        this.checkTime();
      },
      (error) => {
        
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  //kitapçık sayısı değişti
  updateBookletSize(){
    this.bookletSize = Array(this.model.NumberOfBookletList);

    if(this.model.ExamBooklets == null){
      this.model.ExamBooklets = Array(0);
    }

    if(this.model.ExamBooklets.length < this.model.NumberOfBookletList){
      while (this.model.ExamBooklets.length < this.model.NumberOfBookletList) {
        let item = new ExamBookletModel
        item.ExamAnswerLists = [];
        this.model.ExamBooklets.push(item);
      }
    }
    else if(this.model.ExamBooklets.length > this.model.NumberOfBookletList){
      while (this.model.ExamBooklets.length > this.model.NumberOfBookletList) {
        this.model.ExamBooklets.pop();
      }
    }
  }

  //cevap anahtarı sayısı değişti
  updateAnswerListSize(){

    for (let i = 0; i < this.model.ExamBooklets.length; i++){

      if(this.model.ExamBooklets[i].ExamAnswerLists == null){
        this.model.ExamBooklets[i].ExamAnswerLists = Array(0);
      }

      if(this.model.ExamBooklets[i].ExamAnswerLists.length < this.model.NumberOfAnswerList){
        
        while (this.model.ExamBooklets[i].ExamAnswerLists.length < this.model.NumberOfAnswerList) {
          
          let item = new ExamAnswerListModel
          item.ExamAnswerListTitle = 'Liste ' + (this.model.ExamBooklets[i].ExamAnswerLists.length + 1)
          item.NumberOfQuestion = 10
          item.ExamAnswers = []
  
          this.model.ExamBooklets[i].ExamAnswerLists.push(item);
        }
      }
      else if(this.model.ExamBooklets[i].ExamAnswerLists.length > this.model.NumberOfAnswerList){
        while (this.model.ExamBooklets[i].ExamAnswerLists.length > this.model.NumberOfAnswerList) {
          this.model.ExamBooklets[i].ExamAnswerLists.pop();
        }
      }

    }
    
  }

  //şıklar değişti
  updateAnswerTable(){
    this.answerSize = Array(this.model.NumberOfAnswer);

    for (let i = 0; i < this.model.ExamBooklets.length; i++){
      for (let k = 0; k < this.model.ExamBooklets[i].ExamAnswerLists.length; k++) {
      
        if(this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswers == null){
          this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswers = Array(0);
        }
    
        if(this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswers.length < this.model.ExamBooklets[i].ExamAnswerLists[k].NumberOfQuestion){
          
          while (this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswers.length < this.model.ExamBooklets[i].ExamAnswerLists[k].NumberOfQuestion) {
            
            let item = new ExamAnswerModel
            item.QuestionID = this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswers.length + 1;
            item.ExamAnswerListID = this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswerListID;
            item.QuestionAnswerID = null
            
            this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswers.push(item);
          }
        }
        else if(this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswers.length > this.model.ExamBooklets[i].ExamAnswerLists[k].NumberOfQuestion){
          while (this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswers.length > this.model.ExamBooklets[i].ExamAnswerLists[k].NumberOfQuestion) {
            this.model.ExamBooklets[i].ExamAnswerLists[k].ExamAnswers.pop();
          }
        }
      }
    }

  }

  checkTime(){
    let currentDate = new Date;
    
    const diffTime = this.finishDate.getTime() - currentDate.getTime();
    
    if(diffTime <= 0) {
      this.lastTime = new Date(0).toISOString().substr(11, 8);
      this.shouldFinishExam = true;
      this.finishExam();
    }
    else {
      const diffSeconds = Math.ceil(diffTime / 1000);
      this.lastTime = new Date(diffSeconds * 1000).toISOString().substr(11, 8);

      setTimeout(() => {
        this.checkTime();
      }, 1000);
    }

  }

  finishExamConfirmed(){
    this.commonFunctionsService.showConfirmation('warning', 'Emin Misiniz', 'Cevaplarınız kaydedilip sınavınız sonlandırılacaktır. Onaylıyor musunuz?',
    () => {
      this.finishExam();
    }
    )
  }
  
  finishExam(){

    if(this.isFinishing || this.isSaving){
      return;
    }

    this.isFinishing = true;

    this.participantModel.ExamBookletID = this.model.ExamBooklets.filter(eb => eb.ExamBookletIndex == this.currentBookletIndex)[0].ExamBookletID;

    this.participantModel.ExamParticipantAnswers;

    var answers: ExamAnswerModel[] = Array();

    for(var i = 0; i < this.model.ExamBooklets[this.currentBookletIndex].ExamAnswerLists.length; i++){
      answers = answers.concat(this.model.ExamBooklets[this.currentBookletIndex].ExamAnswerLists[i].ExamAnswers);
    }

    this.participantModel.ExamParticipantAnswers = answers;

    this.examService.finishExamForStudent(this.participantModel)
      .subscribe(
        (result) => {
          if (result.Success) {
            this.commonFunctionsService.showNotification('success', "Sınavınız sona erdi", true);
            this.isFinished = true;
            //this.router.navigate(['../'], {relativeTo: this.route});
            //this.onResult.emit(new ResultModel(true, "Sınav kaydı oluşturuldu", result.data));
          }
          else {
            this.commonFunctionsService.showResultNotification(result);
            //this.onResult.emit(result);
          }
        },
        (error) => {
          this.commonFunctionsService.showNotification('error', "Sınav tamamlanırken hata meydana geldi");
          //this.onResult.emit(new ResultModel(false, "Sınav kaydı oluşturulurken hata meydana geldi"));
        },
        () => {
          this.isFinishing = false;
        }
      );
  }

  saveExam(){

    if(this.isFinishing || this.isSaving)
      return;

    this.isSaving = true;

    this.participantModel.ExamBookletID = this.model.ExamBooklets.filter(eb => eb.ExamBookletIndex == this.currentBookletIndex)[0].ExamBookletID;

    this.participantModel.ExamParticipantAnswers;

    var answers: ExamAnswerModel[] = Array();

    for(var i = 0; i < this.model.ExamBooklets[this.currentBookletIndex].ExamAnswerLists.length; i++){
      answers = answers.concat(this.model.ExamBooklets[this.currentBookletIndex].ExamAnswerLists[i].ExamAnswers);
    }

    this.participantModel.ExamParticipantAnswers = answers;

    this.examService.saveExamForStudent(this.participantModel)
      .subscribe(
        (result) => {
          if(this.shouldFinishExam){
            this.commonFunctionsService.showNotification('success', "Sınavınız sona erdi", true);
            this.isFinished = true;
          }
        },
        (error) => {
          
        },
        () => {
          this.isSaving = false;
        }
      );
  }


}
